import { Controller } from 'stimulus'
import LazyLoad from 'vanilla-lazyload'

export default class extends Controller {
  static targets = ['memberTableFrame']

  connect() {
    if (this.hasMemberTableFrameTarget) {
      this.memberTableObserver = new MutationObserver(this.memberTableFrameMutated.bind(this))
      this.memberTableObserver.observe(this.memberTableFrameTarget, { childList: true })
    }
  }

  memberTableFrameMutated() {
    window.feather.replace()
    this.initLazyLoad()
  }

  initLazyLoad() {
    let lazyLoadOptions = { elements_selector: '.lazy' }
    window.pageLazyLoad = new LazyLoad(lazyLoadOptions)
  }

  disconnect() {
    this.memberTableObserver?.disconnect()
  }
}
